import { render, staticRenderFns } from "./MainFaq.vue?vue&type=template&id=73ee7f5a&"
import script from "./MainFaq.vue?vue&type=script&lang=js&"
export * from "./MainFaq.vue?vue&type=script&lang=js&"
import style0 from "./MainFaq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports